var React = require('react');

function Shape7 (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M36.9805 129.425C28.687 121.271 22.0624 110.629 16.2563 100.461C5.86731 82.2448 -4.37118 60.6022 3.4064 41.1628C9.85416 25.0763 26.7075 16.0044 42.7978 9.60483C63.1429 1.53565 87.0517 -4.15936 106.237 6.47326C116.71 12.2762 124.236 22.2059 130.499 32.4152C144.316 54.9617 149.542 82.5336 131.543 104.454C121.544 115.638 109.534 127.164 96.6782 134.924C85.7102 141.545 72.4868 145.343 59.9523 142.624C50.9892 140.685 43.4756 135.822 36.9805 129.425Z"}));
}

Shape7.defaultProps = {"width":"144","height":"144","viewBox":"0 0 144 144","fill":"none"};

module.exports = Shape7;

Shape7.default = Shape7;
